export default __webpack_public_path__ + "images/1b4ae3414a1130df46c8875448441d5d.svg";